module.exports = __webpack_public_path__ + "static/media/icon-instagram.e3b126cf.svg";